/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Status_FailedInputs */

const en_sync_status_failed = /** @type {(inputs: Sync_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending failed`)
};

/**
* | output |
* | --- |
* | "Sending failed" |
*
* @param {Sync_Status_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_status_failed = /** @type {((inputs?: Sync_Status_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Status_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_status_failed(inputs)
});